import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import Portfolio from "./pages/Portfolio";
import Contact from "./pages/Contact";

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

const AppContainer = styled.div`
  width: 100%;
  background: #0a0a0a;
  color: #ffffff;
`;

const Section = styled.section`
  min-height: 100vh;
  position: relative;
  width: 100%;
`;

function App() {
  const sectionsRef = useRef<(HTMLElement | null)[]>([]);

  useEffect(() => {
    // Ensure page starts at the top on load
    window.scrollTo(0, 0);

    // ScrollTrigger animations for each section
    sectionsRef.current.forEach((section, index) => {
      if (section) {
        gsap.fromTo(
          section,
          {
            opacity: 0,
            y: 100,
          },
          {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: section,
              start: "top 80%",
              end: "bottom 20%",
              toggleActions: "play none none reverse",
            },
          }
        );
      }
    });

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  const addToRefs = (el: HTMLElement | null, index: number) => {
    sectionsRef.current[index] = el;
  };

  return (
    <AppContainer>
      <Navbar />
      <Section ref={(el) => addToRefs(el, 0)} id="home">
        <Home />
      </Section>
      <Section ref={(el) => addToRefs(el, 1)} id="about">
        <About />
      </Section>
      <Section ref={(el) => addToRefs(el, 2)} id="portfolio">
        <Portfolio />
      </Section>
      <Section ref={(el) => addToRefs(el, 3)} id="contact">
        <Contact />
      </Section>
    </AppContainer>
  );
}

export default App;
